import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.jpg";
import img4 from "./img/4.png";
import img5 from "./img/5.jpg";
import img6 from "./img/6.jpg";
const services = [
    {
      title: "CCTV Installation and Monitoring",
      description: "State-of-the-art surveillance systems to keep an eye on your property 24/7.",
      image: img1, 
    },
    {
      title: "Access Control Systems",
      description: "Advanced solutions to control who enters and exits your premises.",
      image: img2, 
    },
    {
      title: "Alarm Systems Installation",
      description: "Reliable alarm systems to detect intrusions and alert you instantly.",
      image: img3, 
    },
    {
      title: "Smart Home Security",
      description: "Modern security systems that integrate with your smart home devices for seamless control.",
      image: img4, 
    },
    {
      title: "Business Security Solutions",
      description: "Customized security plans tailored for businesses of all sizes.",
      image: img5, 
    },
    {
      title: "Maintenance and Support",
      description: "Ongoing support and maintenance to ensure your systems work perfectly.",
      image: img6, 
    },
  ];
export default services;